// extracted by mini-css-extract-plugin
export default {"headerContainer":"shipmentReport_headerContainer__-9Ec-"};